import { Helmet } from "react-helmet-async";
import Register from "src/sections/auth/Register";

export default function RegisterPage() {
  return (
    <>
      <Helmet>
        <title> Register | RABill</title>
      </Helmet>

      <Register />
    </>
  );
}
